export const categories = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Sneakers & Footwear',
    count: '320+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20athletic%20sneakers%20on%20clean%20minimal%20white%20surface%2C%20soft%20diffused%20studio%20lighting%20with%20subtle%20warm%20edge%20glow%2C%20modern%20product%20photography%20with%20gentle%20shadows%2C%20fashion%20sneaker%20editorial%20style%2C%20warm%20cream%20background%20with%20subtle%20texture%2C%20high%20detail%20visible%20stitching%20and%20materials&width=800&height=800&seq=cat-shoes-v2-se01&orientation=squarish',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Streetwear & Casual',
    count: '280+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20premium%20cotton%20hoodie%20draped%20elegantly%20on%20light%20natural%20linen%20surface%2C%20soft%20morning%20window%20light%2C%20minimalist%20fashion%20editorial%2C%20warm%20beige%20and%20oatmeal%20color%20palette%2C%20gentle%20fabric%20folds%20visible%2C%20clean%20aesthetic%20commercial%20photography&width=800&height=800&seq=cat-hoodies-v2-se02&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    slug: 'tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Essentials & Graphics',
    count: '410+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20lightweight%20cotton%20tshirt%20folded%20neatly%20on%20warm%20sandy%20beige%20surface%2C%20side%20angle%20natural%20daylight%2C%20gentle%20creases%20visible%2C%20minimal%20clean%20product%20shot%2C%20modern%20casual%20fashion%20aesthetic%2C%20subtle%20warm%20tones%20throughout&width=800&height=800&seq=cat-tshirts-v2-se03&orientation=squarish',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Outerwear & Coats',
    count: '195+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20tailored%20jacket%20hanging%20on%20warm%20wooden%20hanger%20against%20soft%20cream%20wall%2C%20gentle%20directional%20studio%20light%20from%20side%20window%2C%20elegant%20minimal%20display%2C%20fashion%20editorial%20aesthetic%2C%20warm%20earthy%20neutral%20palette%2C%20subtle%20fabric%20texture%20details&width=800&height=800&seq=cat-jackets-v2-se04&orientation=squarish',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Bottoms & Denim',
    count: '230+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Well%20fitted%20casual%20trousers%20laid%20flat%20on%20light%20warm%20stone%20surface%2C%20soft%20overhead%20natural%20lighting%2C%20clean%20minimal%20composition%2C%20subtle%20shadow%20details%2C%20modern%20menswear%20aesthetic%2C%20sandy%20neutral%20background%20palette&width=800&height=800&seq=cat-pants-v2-se05&orientation=squarish',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps & Beanies',
    count: '145+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20structured%20baseball%20cap%20on%20warm%20terracotta%20clay%20surface%2C%20side%20profile%20view%2C%20soft%20directional%20studio%20light%20creating%20gentle%20shadow%2C%20urban%20streetwear%20aesthetic%2C%20minimal%20product%20photography%2C%20warm%20earthy%20tones&width=800&height=800&seq=cat-headwear-v2-se06&orientation=squarish',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Matching Outfits',
    count: '120+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20fashion%20outfit%20set%20of%20jacket%20and%20matching%20pants%20displayed%20on%20warm%20wooden%20surface%2C%20soft%20natural%20light%20from%20large%20window%2C%20editorial%20clothing%20photography%2C%20warm%20neutral%20palette%2C%20elegant%20minimal%20styling&width=800&height=800&seq=cat-sets-v2-se07&orientation=squarish',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Essentials & Basics',
    count: '175+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20essential%20basics%20neatly%20arranged%20on%20light%20warm%20linen%20surface%2C%20gentle%20diffused%20window%20light%2C%20minimal%20clean%20product%20photography%2C%20warm%20cream%20and%20sand%20tones%2C%20elevated%20basics%20editorial%20style&width=800&height=800&seq=cat-underwear-v2-se08&orientation=squarish',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports & Team Wear',
    count: '160+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Athletic%20sports%20jersey%20displayed%20flat%20on%20warm%20neutral%20surface%20with%20subtle%20texture%2C%20soft%20overhead%20studio%20lighting%2C%20modern%20sportswear%20product%20photography%2C%20clean%20minimal%20composition%2C%20warm%20grey%20and%20cream%20tones&width=800&height=800&seq=cat-jersey-v2-se09&orientation=squarish',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Watches & Jewelry',
    count: '250+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20wristwatch%20and%20delicate%20jewelry%20pieces%20arranged%20on%20warm%20cream%20marble%20surface%2C%20soft%20diffused%20daylight%2C%20luxury%20product%20photography%2C%20refined%20modern%20aesthetic%2C%20warm%20golden%20neutral%20palette%2C%20gentle%20reflection%20details&width=800&height=800&seq=cat-access-v2-se10&orientation=squarish',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks & Totes',
    count: '200+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20structured%20leather%20tote%20bag%20on%20warm%20sandy%20beige%20surface%2C%20soft%20natural%20side%20lighting%2C%20elegant%20minimal%20fashion%20accessory%20photography%2C%20warm%20earthy%20neutral%20colors%2C%20subtle%20leather%20texture%20visible&width=800&height=800&seq=cat-bags-v2-se11&orientation=squarish',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Leather & Canvas',
    count: '95+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20genuine%20leather%20belt%20gracefully%20coiled%20on%20warm%20terracotta%20toned%20surface%2C%20soft%20directional%20light%20creating%20gentle%20shadows%2C%20luxury%20accessory%20photography%2C%20rich%20warm%20brown%20and%20cream%20palette%2C%20elegant%20minimal%20composition&width=800&height=800&seq=cat-belts-v2-se12&orientation=squarish',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Fragrances & Scents',
    count: '130+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20soft%20cream%20surface%2C%20gentle%20golden%20hour%20backlight%20creating%20beautiful%20reflections%2C%20luxury%20fragrance%20photography%2C%20minimalist%20refined%20composition%2C%20warm%20amber%20and%20cream%20tones&width=800&height=800&seq=cat-perfume-v2-se13&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'More Discoveries',
    count: '180+ Finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20curated%20collection%20of%20lifestyle%20accessories%20on%20warm%20linen%20surface%2C%20soft%20natural%20morning%20light%2C%20editorial%20flat%20lay%20photography%2C%20warm%20neutral%20and%20sage%20green%20accents%2C%20organic%20composition%20with%20varied%20textures&width=800&height=800&seq=cat-other-v2-se14&orientation=squarish',
  },
];

export const faqItems = [
  {
    question: 'What is Superbuy Spreadsheet?',
    answer: 'Superbuy Spreadsheet is a structured product research resource that helps shoppers organize product information, compare options, review important details, and discover useful shopping opportunities. It provides organized data that makes product discovery faster and more efficient compared to manual browsing.',
  },
  {
    question: 'Is Superbuy Spreadsheet safe to use?',
    answer: 'Yes, Superbuy Spreadsheet is designed as an educational resource. However, we always recommend users independently verify product information, understand seller differences, review shipping options, and protect personal data before making any purchase decisions.',
  },
  {
    question: 'How does Superbuy Spreadsheet work?',
    answer: 'Superbuy Spreadsheet organizes products into categories with structured information. Users can browse through different categories like Shoes, Hoodies, Jackets, and Accessories to quickly find product details, compare options, and discover new items without manually searching through hundreds of pages.',
  },
  {
    question: 'What categories are available in Superbuy Spreadsheet?',
    answer: 'Superbuy Spreadsheet covers a wide range of categories including Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and more. Each category contains organized product information for efficient browsing.',
  },
  {
    question: 'How often is Superbuy Spreadsheet updated?',
    answer: 'Superbuy Spreadsheet resources are regularly maintained and updated to reflect the latest product information and category organization. We strive to keep all product data current and accurate for the best research experience.',
  },
  {
    question: 'Can beginners use Superbuy Spreadsheet?',
    answer: 'Absolutely! Superbuy Spreadsheet is designed with a beginner-friendly approach. The organized structure and clear categories make it easy for anyone to start discovering products, regardless of their experience level with online shopping research.',
  },
  {
    question: 'How does Superbuy Spreadsheet compare to manual searching?',
    answer: 'Compared to manual searching, Superbuy Spreadsheet offers faster product discovery, better organization, easier comparison between options, and significantly reduced research time. Instead of browsing endless pages, users get structured, organized information in one place.',
  },
  {
    question: 'What makes SuperbuySpread.fit different?',
    answer: 'SuperbuySpread.fit is an independent educational platform providing detailed guides, category breakdowns, safety tips, and beginner tutorials about Superbuy Spreadsheet. We go beyond simple product lists to offer comprehensive educational content that helps users make informed decisions.',
  },
  {
    question: 'Are there any costs associated with Superbuy Spreadsheet?',
    answer: 'SuperbuySpread.fit provides free educational content and resources about Superbuy Spreadsheet. We are an independent information platform — always verify specific product pricing and availability through the official channels linked on our site.',
  },
  {
    question: 'How do I get started with Superbuy Spreadsheet?',
    answer: 'Getting started is simple. Browse our category pages to find products you are interested in, explore our educational guides to understand the best research practices, and use the comparison tools to make informed decisions. Click any category above to begin your product discovery journey.',
  },
];

export const comparisonData = [
  {
    label: 'Traditional Search',
    title: 'Manual Browsing',
    description: 'Searching through hundreds of pages individually, comparing products across multiple tabs, and manually organizing research notes takes significant time and effort.',
    features: ['Slow Discovery', 'Unorganized Data', 'Manual Comparison', 'High Time Investment'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Cluttered%20creative%20workspace%20desk%20with%20scattered%20papers%20and%20multiple%20screens%2C%20warm%20afternoon%20light%2C%20slightly%20chaotic%20but%20artistic%20atmosphere%2C%20editorial%20documentary%20style%2C%20soft%20warm%20tones%2C%20tangible%20creative%20process%20aesthetic&width=800&height=600&seq=comp-trad-v2-15&orientation=landscape',
  },
  {
    label: 'Superbuy Spreadsheet',
    title: 'Structured & Fast',
    description: 'Access organized product data across multiple categories instantly. Compare options side by side, discover new items efficiently, and reduce research time dramatically.',
    features: ['Fast Discovery', 'Structured Data', 'Easy Comparison', 'Reduced Research Time'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20serene%20modern%20desk%20setup%20with%20laptop%20and%20organized%20notebook%2C%20warm%20diffused%20window%20light%2C%20calm%20productive%20atmosphere%2C%20minimal%20editorial%20photography%2C%20soft%20cream%20and%20light%20wood%20tones%2C%20peaceful%20mindful%20workspace%20aesthetic&width=800&height=600&seq=comp-super-v2-16&orientation=landscape',
  },
  {
    label: 'Time Saving',
    title: 'Faster Decisions',
    description: 'With organized information at your fingertips, make confident purchasing decisions faster. Spend less time searching and more time discovering products you will love.',
    features: ['Organized Browsing', 'Category Filtering', 'Quick Discovery', 'Confident Choices'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Relaxed%20person%20in%20bright%20airy%20modern%20cafe%20with%20coffee%20and%20laptop%2C%20warm%20natural%20sunlight%20through%20large%20windows%2C%20genuine%20smile%2C%20lifestyle%20editorial%20photography%2C%20clean%20contemporary%20interior%2C%20soft%20warm%20beige%20and%20cream%20tones%2C%20authentic%20candid%20moment&width=800&height=600&seq=comp-save-v2-17&orientation=landscape',
  },
];